<template>
  <div class="tag-list">
    <div class="list-header">
      <h2>标签管理</h2>
      <el-button type="primary" @click="showAddModal = true">新增标签</el-button>
    </div>
    <el-table :data="tags" border>
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="name" label="标签名称"></el-table-column>
      <el-table-column prop="articleCount" label="文章数量"></el-table-column>
      <el-table-column prop="createdAt" label="创建时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="editTag(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteTag(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="新增/编辑标签" :visible.sync="showAddModal">
      <el-form :model="tagForm" label-width="80px">
        <el-form-item label="标签名称">
          <el-input v-model="tagForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showAddModal = false">取消</el-button>
        <el-button type="primary" @click="saveTag">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTags, saveTag, deleteTag } from '@/api/blog'

export default {
  name: 'TagList',
  data() {
    return {
      tags: [],
      showAddModal: false,
      tagForm: {
        id: null,
        name: ''
      }
    }
  },
  mounted() {
    this.loadTags()
  },
  methods: {
    async loadTags() {
      const res = await getTags()
      this.tags = res.data
    },
    editTag(row) {
      this.tagForm = {
        id: row.id,
        name: row.name
      }
      this.showAddModal = true
    },
    async saveTag() {
      await saveTag(this.tagForm)
      this.showAddModal = false
      this.loadTags()
      this.$message.success('保存成功')
    },
    async deleteTag(id) {
      if (confirm('确定要删除这个标签吗？')) {
        await deleteTag(id)
        this.loadTags()
        this.$message.success('删除成功')
      }
    }
  }
}
</script>

<style scoped>
.tag-list {
  padding: 20px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
